import { useEffect, useState, useRef } from "react"

export function useScroll() {
    const [fixed, setFixed] = useState(false)
    const element = useRef(null)

    const handleScroll = () => {
        window.scrollY > element.current.getBoundingClientRect().bottom
            ? setFixed(true)
            : setFixed(false)
    }

    // This function handle the scroll performance issue
    const debounce = (func, wait = 10, immediate = true) => {
        let timeOut
        return () => {
            // @ts-ignore
            let context = this, args = arguments
            const later = () => {
                timeOut = null
                if (!immediate) func.apply(context, args)
            }
            const callNow = immediate && !timeOut
            clearTimeout(timeOut)
            timeOut = setTimeout(later, wait)
            if (callNow) func.apply(context, args)
        }
    }

    useEffect(() => {
        window.addEventListener("scroll", debounce(handleScroll))
        return () => {
            window.removeEventListener("scroll", () => handleScroll)
        }
    }, [debounce, handleScroll])

    return { fixed, element }
}